import React, { Component } from "react";
import PropTypes from "prop-types";
import Dialog from "../../../../UiComponents/Dialog";
import getLabel from "./../../../../../utils/labels";
import styles from "./multipleOptions.module.scss";
import MessageOptionItem from "../messageOptionItem";

class MultipleOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			id: props.id,
			selectedOptionArray: [],
			numberOfOptionsRemaining: 0 //Flag to check number of answers selected
		};
	}

	checkIfOptionPresentInArray = (array, element) => {
		return array.includes(element);
	};

	onOptionClick = id => {
		const { options } = this.props;
		const { selectedOptionArray } = this.state;

		if (!this.checkIfOptionPresentInArray(selectedOptionArray, id)) {
			this.setState(prevState => ({
				selectedOptionArray: [...prevState.selectedOptionArray, id]
			}));
		} else {
			this.setState(prevState => ({
				selectedOptionArray: prevState.selectedOptionArray.filter(
					x => x !== id
				)
			}));
		}
	};

	clearSelectedOptionArray = () => {
		this.setState({
			selectedOptionArray: []
		});
		this.props.handleClose();
	};

	getWarningMessageText = numberOfOptionsRemaining => {
		let { max_no_of_answers } = this.props;

		if (numberOfOptionsRemaining < 0) {
			return getLabel('label_select_n_options_warning').replace('${max_no_of_answers}', max_no_of_answers);
		} else if (numberOfOptionsRemaining > 0) {
			return getLabel('label_select_n_options_warning').replace('${max_no_of_answers}', max_no_of_answers);
		} else {
			return null;
		}
	};

	updateData = () => {
		//updateing parent compoennt
		let { selectedOptionArray } = this.state;
		let { max_no_of_answers } = this.props;

		//If the number of answers selected is not equal to the max number given, set the flag
		if (selectedOptionArray.length !== max_no_of_answers) {
			this.setState({
				numberOfOptionsRemaining:
					selectedOptionArray.length - max_no_of_answers
			});
		} else {
			this.setState({
				numberOfOptionsRemaining: 0
			});
			this.props.updateBody(this.state.id, selectedOptionArray);
			this.props.handleClose();
		}
	};

	render() {
		const { options, max_no_of_answers } = this.props;
		const { selectedOptionArray, numberOfOptionsRemaining } = this.state;

		const getMessageList = () =>
			options.map((option, key) => {
				return (
					<MessageOptionItem
						{...option}
						key={key}
						selectedOptionArray={this.state.selectedOptionArray}
						onClick={this.onOptionClick}
						isHighlighted={this.checkIfOptionPresentInArray(
							selectedOptionArray,
							option.id
						)}
					/>
				);
			});

		return (
			<Dialog
				//Change this title later - need to change db
				title={getLabel('label_select_n_options_title').replace('${max_no_of_answers}', max_no_of_answers)}
				overlayClassName={styles.dialog}
				containerClassName={styles["overlay-container"]}
				onClose={this.handleClose}
				warningMessage={this.getWarningMessageText(
					numberOfOptionsRemaining
				)}
				buttons={[
					{
						text: getLabel('label_cancel_button'),
						onClick: () => this.clearSelectedOptionArray(),
						className: styles["cancel-button"]
					},
					{
						text: getLabel('label_add_button'),
						onClick: () => this.updateData(),
						className: styles["ok-button"]
					}
				]}
				hideOverflow={true}
				contentStyle={{ height: "calc(100% - 90px)" }}
			>
				<div className={styles["message-list"]}>{getMessageList()}</div>
			</Dialog>
		);
	}
}

MultipleOptions.propTypes = {
	options: PropTypes.array,
	handleClose: PropTypes.func,
	updateBody: PropTypes.func,
	id: PropTypes.number
};

MultipleOptions.defaultProps = {};

export default MultipleOptions;



// WEBPACK FOOTER //
// /src/components/mailThread/compose/messageHandler/multipleOptions/MultipleOptions.js